<template>
<!--
      icon="mdi-vuetify"
-->
  <base-section id="about-our-product">
    <base-section-heading
      color="grey lighten-2"
      title="About Us"
    />

    <v-container>
      <v-row>
        <v-col
          v-for="card in cards"
          :key="card.title"
          cols="12"
          md="6"
        >
          <base-info-card v-bind="card" />
        </v-col>
      </v-row>
    </v-container>
        <span class="trace">AboutOurProduct.vue</span>

  </base-section>
</template>

<script>
  export default {
    name: 'SectionAboutOurProduct',

    data: () => ({
      cards: [
        {
          title: 'Our Mission',
          subtitle: '',
          text: 'We provide information about local environmental issues and resources and organize practical projects aimed at safeguarding Truro’s water and reducing Truro’s collective carbon footprint.',
          callout: '',
        },
        {
          title: 'Our Vision',
          subtitle: '',
          text: 'We envision a resilient, ecologically healthy, environmentally responsible community living without pollutants in our water, land, and air.',
          callout: '',
        },
        /*
        {
          title: 'Target Setting',
          subtitle: 'Income Flow',
          text: 'Similique sunt in culpa qui officia deserunt mollitia animi, id est laborut dolorum fuga.harum quidem rerum facilis estexpedita distinctio.',
          callout: '03',
        },
        */
      ],
    }),
  }
</script>
